<template>
  <span class="svg-icon-message-question">
    <svg
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M22.6666 24.5736H17.3333L11.3999 28.5203C10.5199 29.1069 9.33329 28.4802 9.33329 27.4136V24.5736C5.33329 24.5736 2.66663 21.9069 2.66663 17.9069V9.9069C2.66663 5.9069 5.33329 3.24023 9.33329 3.24023H22.6666C26.6666 3.24023 29.3333 5.9069 29.3333 9.9069V17.9069C29.3333 21.9069 26.6666 24.5736 22.6666 24.5736Z" :fill="color"/>
      <path d="M16 16.1465C15.4534 16.1465 15 15.6932 15 15.1465V14.8665C15 13.3199 16.1334 12.5599 16.56 12.2665C17.0534 11.9332 17.2133 11.7065 17.2133 11.3599C17.2133 10.6932 16.6667 10.1465 16 10.1465C15.3334 10.1465 14.7867 10.6932 14.7867 11.3599C14.7867 11.9065 14.3334 12.3599 13.7867 12.3599C13.2401 12.3599 12.7867 11.9065 12.7867 11.3599C12.7867 9.58653 14.2267 8.14648 16 8.14648C17.7734 8.14648 19.2133 9.58653 19.2133 11.3599C19.2133 12.8799 18.0934 13.6398 17.6801 13.9198C17.1601 14.2665 17 14.4932 17 14.8665V15.1465C17 15.7065 16.5467 16.1465 16 16.1465Z" :fill="color"/>
      <path d="M16 19.4668C15.44 19.4668 15 19.0135 15 18.4668C15 17.9201 15.4533 17.4668 16 17.4668C16.5467 17.4668 17 17.9201 17 18.4668C17 19.0135 16.56 19.4668 16 19.4668Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 28 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
